export default "__VITE_ASSET__DBVvWD31__"